
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34811',
  depVersions: {
  "documents-public-ui": "static-1.34811",
  "atom": "static-1.5201",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2624",
  "client-types": "static-1.482",
  "cssUtils": "static-1.827",
  "customer-data-filters-ui": "static-1.40227",
  "customer-data-objects": "static-1.7804",
  "customer-data-property-utils": "static-1.8220",
  "documents-lib": "static-1.34816",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.347",
  "FormsCommonComponents": "static-1.86150",
  "FormUrlGenerator": "static-2.4847",
  "foundations-theming-specialty": "static-1.2274",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5718",
  "hs-test-utils": "static-1.8145",
  "hub-http": "static-1.6348",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11903",
  "HubStyleTokens": "static-2.11596",
  "I18n": "static-7.1640",
  "icons": "static-2.655",
  "jasmine-immutable": "static-1.3147",
  "jasmine-runner": "static-1.6583",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7278",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5522",
  "quartz": "static-1.7193",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16809",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5434",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8301",
  "reference-resolvers-lite": "static-1.8222",
  "reporting-data": "static-1.68064",
  "reporting-reports": "static-1.67742",
  "reporting-snowflake": "static-1.56682",
  "reporting-testing-lib": "static-1.9997",
  "reporting-visualizations": "static-1.60140",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9073",
  "sanitize": "static-1.4602",
  "sanitize-text": "static-1.8272",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1870",
  "signup-constants": "static-1.19163",
  "signup-ui-url-generator": "static-2.8183",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4885",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4885",
  "ui-addon-form-validation": "static-1.11116",
  "ui-asset-management-lib": "static-1.11194",
  "ui-images": "static-2.1185",
  "UIComponents": "static-3.8542",
  "usage-tracker": "static-1.7476",
  "usage-tracker-container": "static-1.7466",
  "usage-tracker-core": "static-1.7326",
  "viral-links-lib": "static-1.7195",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9787",
  "foundations-components": "static-1.8184",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.971",
  "quartz-core": "static-1.6412",
  "quick-fetch": "static-1.4010",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4782",
  "ui-addon-i18n": "static-1.11274",
  "ui-addon-upgrades": "static-9.18165",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3492",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3470",
  "quartz-webpack": "static-1.3417",
  "foundations-assets": "static-1.4999",
  "foundations-theming": "static-1.4558",
  "hub-http-shared-msw-handlers": "static-1.10273",
  "hubspotter-http": "static-1.4743",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7372",
  "crm-message-bus": "static-1.43308",
  "customer-data-filters-ui-msw-helpers": "static-1.22662",
  "customer-data-objects-ui-components": "static-1.13154",
  "customer-data-reference-ui-components": "static-1.13300",
  "customer-data-ui-utilities": "static-1.9950",
  "events-data-lib": "static-1.359",
  "framework-builder-read-service-client": "static-1.4097",
  "framework-data-schema-quick-fetch": "static-1.6924",
  "framework-data-schema-resolvers": "static-1.7019",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3679",
  "inbound-db-properties-service-client": "static-1.3939",
  "multi-account-reference-resolvers": "static-1.1107",
  "onboarding-tours": "static-1.16839",
  "reporting-datasets-permissions-lib": "static-1.14035",
  "ui-addon-teams": "static-1.21713",
  "quartz-auth": "static-1.868",
  "ui-business-units-lib": "static-1.9192",
  "usage-tracker-session-replay": "static-1.5162",
  "ai-components-ui-library": "static-1.9271",
  "ContentUtils": "static-1.68729",
  "customer-data-properties": "static-1.51988",
  "forms-ai-lib": "static-1.4518",
  "forms-utils-lib": "static-1.12820",
  "foundations-components-test-utils": "static-1.5667",
  "react-dnd-compat": "static-1.4740",
  "react-tinymce": "static-1.55571",
  "tinymce-config": "static-2.54697",
  "ui-gdpr-components": "static-1.10476",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3543",
  "HeadJS": "static-2.772",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3256",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.174",
  "ui-fonts": "static-1.858",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4451",
  "csstype": "static-1.50",
  "quartz-head": "static-1.858",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1669",
  "external-options-client-types": "static-1.4219",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.868",
  "frontend-preferences-client": "static-1.8052",
  "graphql": "static-1.83",
  "persist-promise": "static-1.3826",
  "reporting-client-types": "static-1.2576",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25739",
  "hubspot-apollo-client": "static-1.5003",
  "foundations-components-legacy": "static-1.1209",
  "quartz-routing": "static-1.623",
  "hs-story-utils": "static-1.9549",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.359",
  "timezone-utils": "static-2.5368",
  "seat-types-lib": "static-1.288",
  "react-create-root-preference": "static-1.38",
  "bend-plugin-foundations-components": "static-1.4453",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2207",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.847",
  "mobile-manifest-mixins": "static-1.546",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.868",
  "quartz-tracking": "static-1.572",
  "trellis-components": "static-1.2226",
  "bend-plugin-chirp-manifest": "static-1.192",
  "chirp-fetch": "static-1.2013",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6105",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4174",
  "bender-build-tools": "static-1.3297",
  "bend-plugin-foundations-theming": "static-1.3041",
  "stylex": "static-1.35",
  "restore-request-side-panel-lib": "static-1.1190",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.301",
  "pulse": "static-1.729",
  "conditional-properties-service-client": "static-1.3890",
  "crm-pipelines-api-client-types": "static-1.4229",
  "fdsr-migration-layer": "static-1.138",
  "multi-currency-client-types": "static-1.3783",
  "getting-started-shared-tasks": "static-1.18754",
  "growth-data-modal": "static-1.5633",
  "growth-onboarding-confetti": "static-1.3191",
  "growth-onboarding-next-action-utils": "static-1.2270",
  "navigation-components": "static-1.18314",
  "onboarding-tours-client": "static-1.5053",
  "onboarding-tours-utils": "static-1.905",
  "ui-shepherd-react": "static-3.10379",
  "ui-shepherd-tracker": "static-1.7760",
  "ui-universal-auth": "static-1.9129",
  "user-context": "static-1.5234",
  "hubspotter-http-shared-msw-handlers": "static-1.10271",
  "magpie-lib": "static-1.5635",
  "navigation-messaging": "static-1.7641",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21899",
  "copilot-toolkit": "static-1.11454",
  "cms-field-types": "static-1.4940",
  "content-icons-ui": "static-1.2261",
  "integrations-lib": "static-1.16544",
  "calling-global-api": "static-1.64931",
  "calling-internal-common": "static-1.31436",
  "calling-lifecycle-internal": "static-1.66313",
  "calling-lifecycle-messages": "static-1.58607",
  "commerce-products-lib": "static-1.10025",
  "crm-links": "static-1.6434",
  "customer-data-properties-shared-msw-handlers": "static-1.9600",
  "file-manager-components": "static-1.23969",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4310",
  "meetings-icalendar-utils-lib": "static-1.758",
  "object-builder-ui-client": "static-1.49168",
  "pipeline-validation-client-types": "static-1.4058",
  "property-value-citations": "static-1.2602",
  "smart-property-lib": "static-1.7884",
  "tiered-pricing": "static-1.1545",
  "ui-addon-iframeable": "static-1.9192",
  "zustand": "static-1.74",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20051",
  "tinymce-themes": "static-1.56667",
  "data-token-picker": "static-1.16633",
  "hub-http-contrib": "static-1.3168",
  "interframe": "static-3.4885",
  "tinymce-data": "static-1.40782",
  "tinymce-plugins": "static-1.57811",
  "ui-addon-sales-email": "static-1.5336",
  "onboarding-scopes": "static-1.6586",
  "ui-addon-opt": "static-4.8487",
  "apollo-link-hub-http": "static-2.4777",
  "hubspot-apollo-cache": "static-1.462",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.299",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1066",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6108",
  "event-emitter": "static-1.1075",
  "bend-plugin-pulse": "static-1.232",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2182",
  "growth-onboarding-next-action-components": "static-1.2298",
  "user-context-client": "static-1.4705",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5095",
  "nest": "static-1.358",
  "reactive-lib": "static-1.851",
  "simple-logging-lib": "static-1.3174",
  "unified-auth-core-lib": "static-1.925",
  "getting-started-shared-tasks-store": "static-1.17872",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1147",
  "integrations-error-boundary-lib": "static-1.13959",
  "integrations-tracking-lib": "static-1.5732",
  "native-integrations-shared-strings": "static-1.7907",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10487",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.643",
  "calling-error-reporting": "static-1.31443",
  "shared-worker-versioning": "static-1.11161",
  "calling-usage-tracker": "static-1.6669",
  "voice-sms-access-library": "static-1.1461",
  "customer-data-tracking": "static-1.7012",
  "commerce-permissions": "static-1.901",
  "products-iframe-lib": "static-1.8273",
  "products-ui-components-shared-msw-handlers": "static-1.10655",
  "location-customization-utils-lib": "static-1.9613",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4275",
  "video-components-external": "static-1.11679",
  "video-data-lib": "static-1.35337",
  "data-agent-kit": "static-1.405",
  "feedback-loader": "static-1.29534",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10356",
  "fsm": "static-1.3856",
  "policy-lib": "static-1.6911",
  "react-colorpicker": "static-2.10333",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10419",
  "FileManagerLib": "static-1.39609",
  "NamespacedHubStyle": "static-2.9146",
  "FileManagerCore": "static-1.39468",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7956",
  "layout-dnd-components": "static-1.12690",
  "layout-dnd-utils": "static-1.11665",
  "react-codemirror": "static-1.10753",
  "ui-addon-emoji-picker": "static-1.10012",
  "ui-brand-identity-lib": "static-1.15726",
  "InboxConnectUtils": "static-4.15138",
  "meetings-connect-utils-lib": "static-1.7730",
  "breeze-engine-core": "static-1.425",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3137",
  "adobe-sign-auth-lib": "static-1.37",
  "ads-unified-auth-lib": "static-1.409",
  "google-sheets-integration-lib": "static-1.600",
  "microsoft-drive-integration-lib": "static-1.746",
  "surveymonkey-integration-lib": "static-1.55",
  "slack-ui-library": "static-1.10522",
  "calling-orchestration-schema": "static-1.36238",
  "sales-views-client-types": "static-1.4382",
  "crm-record-cards-service-types": "static-1.3678",
  "content-media-composition-data-lib": "static-1.12693",
  "content-media-compositions": "static-2.16700",
  "media-bridge-lib": "static-1.19146",
  "trellis-story-utils": "static-1.4636",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6112",
  "FileManagerImages": "static-1.37120",
  "video-components": "static-1.13681",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4661",
  "video-embed": "static-1.36171",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8830",
  "ui-coaching-tips": "static-1.28902",
  "ContentData": "static-1.68804",
  "layout-data-lib": "static-1.9990",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22366",
  "outpost": "static-1.4293",
  "growth-onboarding-feedback-components": "static-1.6704",
  "advanced-menus-core": "static-1.15339",
  "advanced-menus-lib": "static-1.12250",
  "ExportDialog": "static-6.10505",
  "ui-memberships-settings-lib": "static-1.34373",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15338",
  "simple-menus-lib": "static-1.16855"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34811",
  "atom": "/atom/static-1.5201",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2624",
  "client-types": "/client-types/static-1.482",
  "cssUtils": "/cssUtils/static-1.827",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40227",
  "customer-data-objects": "/customer-data-objects/static-1.7804",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8220",
  "documents-lib": "/documents-lib/static-1.34816",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.347",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86150",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4847",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2274",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5718",
  "hs-test-utils": "/hs-test-utils/static-1.8145",
  "hub-http": "/hub-http/static-1.6348",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11903",
  "HubStyleTokens": "/HubStyleTokens/static-2.11596",
  "I18n": "/I18n/static-7.1640",
  "icons": "/icons/static-2.655",
  "jasmine-immutable": "/jasmine-immutable/static-1.3147",
  "jasmine-runner": "/jasmine-runner/static-1.6583",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7278",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5522",
  "quartz": "/quartz/static-1.7193",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16809",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5434",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8301",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8222",
  "reporting-data": "/reporting-data/static-1.68064",
  "reporting-reports": "/reporting-reports/static-1.67742",
  "reporting-snowflake": "/reporting-snowflake/static-1.56682",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9997",
  "reporting-visualizations": "/reporting-visualizations/static-1.60140",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9073",
  "sanitize": "/sanitize/static-1.4602",
  "sanitize-text": "/sanitize-text/static-1.8272",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1870",
  "signup-constants": "/signup-constants/static-1.19163",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8183",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4885",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4885",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11116",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11194",
  "ui-images": "/ui-images/static-2.1185",
  "UIComponents": "/UIComponents/static-3.8542",
  "usage-tracker": "/usage-tracker/static-1.7476",
  "usage-tracker-container": "/usage-tracker-container/static-1.7466",
  "usage-tracker-core": "/usage-tracker-core/static-1.7326",
  "viral-links-lib": "/viral-links-lib/static-1.7195",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9787",
  "foundations-components": "/foundations-components/static-1.8184",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.971",
  "quartz-core": "/quartz-core/static-1.6412",
  "quick-fetch": "/quick-fetch/static-1.4010",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4782",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11274",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18165",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3492",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3470",
  "quartz-webpack": "/quartz-webpack/static-1.3417",
  "foundations-assets": "/foundations-assets/static-1.4999",
  "foundations-theming": "/foundations-theming/static-1.4558",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10273",
  "hubspotter-http": "/hubspotter-http/static-1.4743",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7372",
  "crm-message-bus": "/crm-message-bus/static-1.43308",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22662",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13154",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13300",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9950",
  "events-data-lib": "/events-data-lib/static-1.359",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4097",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6924",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7019",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3679",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3939",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1107",
  "onboarding-tours": "/onboarding-tours/static-1.16839",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14035",
  "ui-addon-teams": "/ui-addon-teams/static-1.21713",
  "quartz-auth": "/quartz-auth/static-1.868",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9192",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5162",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9271",
  "ContentUtils": "/ContentUtils/static-1.68729",
  "customer-data-properties": "/customer-data-properties/static-1.51988",
  "forms-ai-lib": "/forms-ai-lib/static-1.4518",
  "forms-utils-lib": "/forms-utils-lib/static-1.12820",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5667",
  "react-dnd-compat": "/react-dnd-compat/static-1.4740",
  "react-tinymce": "/react-tinymce/static-1.55571",
  "tinymce-config": "/tinymce-config/static-2.54697",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10476",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3543",
  "HeadJS": "/HeadJS/static-2.772",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3256",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.174",
  "ui-fonts": "/ui-fonts/static-1.858",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4451",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.858",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1669",
  "external-options-client-types": "/external-options-client-types/static-1.4219",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.868",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8052",
  "graphql": "/graphql/static-1.83",
  "persist-promise": "/persist-promise/static-1.3826",
  "reporting-client-types": "/reporting-client-types/static-1.2576",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25739",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5003",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1209",
  "quartz-routing": "/quartz-routing/static-1.623",
  "hs-story-utils": "/hs-story-utils/static-1.9549",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.359",
  "timezone-utils": "/timezone-utils/static-2.5368",
  "seat-types-lib": "/seat-types-lib/static-1.288",
  "react-create-root-preference": "/react-create-root-preference/static-1.38",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4453",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2207",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.847",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.546",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.868",
  "quartz-tracking": "/quartz-tracking/static-1.572",
  "trellis-components": "/trellis-components/static-1.2226",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.192",
  "chirp-fetch": "/chirp-fetch/static-1.2013",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6105",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4174",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3041",
  "stylex": "/stylex/static-1.35",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1190",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.301",
  "pulse": "/pulse/static-1.729",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3890",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4229",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.138",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3783",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18754",
  "growth-data-modal": "/growth-data-modal/static-1.5633",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3191",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2270",
  "navigation-components": "/navigation-components/static-1.18314",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5053",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.905",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10379",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7760",
  "ui-universal-auth": "/ui-universal-auth/static-1.9129",
  "user-context": "/user-context/static-1.5234",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10271",
  "magpie-lib": "/magpie-lib/static-1.5635",
  "navigation-messaging": "/navigation-messaging/static-1.7641",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21899",
  "copilot-toolkit": "/copilot-toolkit/static-1.11454",
  "cms-field-types": "/cms-field-types/static-1.4940",
  "content-icons-ui": "/content-icons-ui/static-1.2261",
  "integrations-lib": "/integrations-lib/static-1.16544",
  "calling-global-api": "/calling-global-api/static-1.64931",
  "calling-internal-common": "/calling-internal-common/static-1.31436",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66313",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58607",
  "commerce-products-lib": "/commerce-products-lib/static-1.10025",
  "crm-links": "/crm-links/static-1.6434",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9600",
  "file-manager-components": "/file-manager-components/static-1.23969",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4310",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.758",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49168",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4058",
  "property-value-citations": "/property-value-citations/static-1.2602",
  "smart-property-lib": "/smart-property-lib/static-1.7884",
  "tiered-pricing": "/tiered-pricing/static-1.1545",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9192",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20051",
  "tinymce-themes": "/tinymce-themes/static-1.56667",
  "data-token-picker": "/data-token-picker/static-1.16633",
  "hub-http-contrib": "/hub-http-contrib/static-1.3168",
  "interframe": "/interframe/static-3.4885",
  "tinymce-data": "/tinymce-data/static-1.40782",
  "tinymce-plugins": "/tinymce-plugins/static-1.57811",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5336",
  "onboarding-scopes": "/onboarding-scopes/static-1.6586",
  "ui-addon-opt": "/ui-addon-opt/static-4.8487",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4777",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.462",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.299",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1066",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6108",
  "event-emitter": "/event-emitter/static-1.1075",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.232",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2182",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2298",
  "user-context-client": "/user-context-client/static-1.4705",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5095",
  "nest": "/nest/static-1.358",
  "reactive-lib": "/reactive-lib/static-1.851",
  "simple-logging-lib": "/simple-logging-lib/static-1.3174",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.925",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17872",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1147",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13959",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5732",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7907",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10487",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.643",
  "calling-error-reporting": "/calling-error-reporting/static-1.31443",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11161",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6669",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1461",
  "customer-data-tracking": "/customer-data-tracking/static-1.7012",
  "commerce-permissions": "/commerce-permissions/static-1.901",
  "products-iframe-lib": "/products-iframe-lib/static-1.8273",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10655",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9613",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4275",
  "video-components-external": "/video-components-external/static-1.11679",
  "video-data-lib": "/video-data-lib/static-1.35337",
  "data-agent-kit": "/data-agent-kit/static-1.405",
  "feedback-loader": "/feedback-loader/static-1.29534",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10356",
  "fsm": "/fsm/static-1.3856",
  "policy-lib": "/policy-lib/static-1.6911",
  "react-colorpicker": "/react-colorpicker/static-2.10333",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10419",
  "FileManagerLib": "/FileManagerLib/static-1.39609",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9146",
  "FileManagerCore": "/FileManagerCore/static-1.39468",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7956",
  "layout-dnd-components": "/layout-dnd-components/static-1.12690",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11665",
  "react-codemirror": "/react-codemirror/static-1.10753",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10012",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15726",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15138",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7730",
  "breeze-engine-core": "/breeze-engine-core/static-1.425",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3137",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.37",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.409",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.600",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.746",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.55",
  "slack-ui-library": "/slack-ui-library/static-1.10522",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36238",
  "sales-views-client-types": "/sales-views-client-types/static-1.4382",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3678",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12693",
  "content-media-compositions": "/content-media-compositions/static-2.16700",
  "media-bridge-lib": "/media-bridge-lib/static-1.19146",
  "trellis-story-utils": "/trellis-story-utils/static-1.4636",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6112",
  "FileManagerImages": "/FileManagerImages/static-1.37120",
  "video-components": "/video-components/static-1.13681",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4661",
  "video-embed": "/video-embed/static-1.36171",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8830",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28902",
  "ContentData": "/ContentData/static-1.68804",
  "layout-data-lib": "/layout-data-lib/static-1.9990",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22366",
  "outpost": "/outpost/static-1.4293",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6704",
  "advanced-menus-core": "/advanced-menus-core/static-1.15339",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12250",
  "ExportDialog": "/ExportDialog/static-6.10505",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34373",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15338",
  "simple-menus-lib": "/simple-menus-lib/static-1.16855"
}
};
